import styled from 'styled-components';

export const Container = styled.div`
  > span {
    color: #0769ba;
  }
`;
